import { Dimensions, StyleSheet } from 'react-native'


export default StyleSheet.create({
  container: (insets, isLoading) => ({
    flexGrow: isLoading ? 0 : 1,
    paddingBottom: insets.bottom + 10,
    paddingHorizontal: Dimensions.get('window').width > 700 && '10%'
  })
})
